import { track } from "jiffy-analytics";
import { tryParse } from "common/utils/json";
import "./mockup-tool-modal.scss";

const $getActiveCarouselWrapper = () => document.querySelector(".js-carousel-wrapper:not(.hidden)");
const $getActiveCarouselItem = () =>
  $getActiveCarouselWrapper()?.querySelector(
    ".js-carousel-item:not(.product-details-image-carousel__item--hidden)"
  );
const $getActiveImage = () => $getActiveCarouselItem()?.querySelector(".js-carousel-image");
const $getMockupTrigger = () => document.querySelector(".js-mockup-trigger");
const $getIframe = () => document.querySelector(".js-mockup-iframe");
const $getErrorMsg = () => document.querySelector(".js-mockup-error-msg");
const $getLoader = () => document.querySelector(".js-mockup-loader");

const $$modal = $(".mockup-tool-modal");
const $iframe = $getIframe();

const RESERVED_WIDTH = 388; // Upload Box and spacings
const RESERVED_HEIGHT = 160; // Popup title and spacings

let loadingMockup = false;
let onLoadTimeout;
const LOAD_TIMEOUT = 30000; // 30 seconds

const resetModal = () => {
  if (onLoadTimeout) clearTimeout(onLoadTimeout);

  loadingMockup = false;

  $iframe.setAttribute("src", "");
  $iframe.classList.add("invisible");

  $getErrorMsg().classList.add("invisible");
  $getLoader().classList.remove("invisible");
};

const getModalPadding = () => {
  const element = document.querySelector(".mockup-tool-modal__body");
  const computedStyle = getComputedStyle(element);
  return parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
};

const calculateScaledImageSize = (width, height) => {
  const maxWidth = window.innerWidth - RESERVED_WIDTH;
  const maxHeight = window.innerHeight - RESERVED_HEIGHT;

  const widthRatio = maxWidth / width;
  const heightRatio = maxHeight / height;
  const scaleFactor = Math.min(widthRatio, heightRatio, 1);

  let scaledWidth = Math.floor(width * scaleFactor);
  let scaledHeight = Math.floor(height * scaleFactor);

  if (scaledWidth > maxWidth || scaledHeight > maxHeight) {
    const widthAdjustment = maxWidth / scaledWidth;
    const heightAdjustment = maxHeight / scaledHeight;
    const adjustmentFactor = Math.min(widthAdjustment, heightAdjustment);

    scaledWidth = Math.floor(scaledWidth * adjustmentFactor);
    scaledHeight = Math.floor(scaledHeight * adjustmentFactor);
  }

  return [scaledWidth, scaledHeight];
};

const calculateScaledImageSizeOfUrl = imgUrl =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const { width, height } = img;
      resolve(calculateScaledImageSize(width, height));
    };
    img.onerror = () => {
      reject(new Error("Error loading image"));
    };
    img.src = imgUrl;
  });

const showLoadingFailedError = () => {
  $getLoader().classList.add("invisible");
  $getErrorMsg().classList.remove("invisible");
};

const buildUrlParams = baseParams => {
  const { userHashedId, pictureId, ...rest } = baseParams;
  const jsonData = {
    user_hashed_id: userHashedId,
    picture_id: pictureId,
    ...rest
  };
  return `data=${btoa(JSON.stringify(jsonData))}`;
};

const initMockupTrigger = () => {
  const $mockupTrigger = $getMockupTrigger();
  $mockupTrigger?.addEventListener("click", async () => {
    if (loadingMockup) return;

    loadingMockup = true;
    onLoadTimeout = setTimeout(showLoadingFailedError, LOAD_TIMEOUT);

    const { url, mixpanelData, ...otherMockupData } = $mockupTrigger.dataset;
    const trackData = tryParse(mixpanelData);
    const $activeImg = $getActiveImage();
    const activeImgUrl = new URL($activeImg.src);
    const pictureUrl = `${activeImgUrl.origin}${activeImgUrl.pathname}?remove-bg=true`;

    let { width, height } = $activeImg.dataset;
    if (width && height) {
      [width, height] = calculateScaledImageSize(Number(width), Number(height));
    } else {
      [width, height] = await calculateScaledImageSizeOfUrl(pictureUrl);
    }

    const urlParams = buildUrlParams({
      width,
      height,
      ...otherMockupData,
      picture: pictureUrl,
      composition: trackData.composition,
      catalog_number: trackData.catalog_number
    });
    const iframeSrc = `${url}?${urlParams}`;

    $iframe.setAttribute("src", iframeSrc);
    $iframe.setAttribute("width", width + RESERVED_WIDTH - getModalPadding());
    $iframe.setAttribute("height", height);

    $$modal.modal("show");

    track("create_mockup_clicked", { image: pictureUrl, ...trackData });
  });
};

export default () => {
  if (!$$modal || !$iframe) return;

  window.addEventListener("message", event => {
    if (event.data === "iframeLoaded") {
      if (onLoadTimeout) clearTimeout(onLoadTimeout);
      loadingMockup = false;
      $getLoader().classList.add("invisible");
      $iframe.classList.remove("invisible");
    }
  });

  $$modal.on("hidden.bs.modal", () => {
    resetModal();
    track("create_mockup_closed");
  });

  initMockupTrigger();
};
